import { useState } from "react";
import { Order } from "../../../../__generated__/graphql";

interface CancelSelectionModeResult {
  /** 선택 모드 시작 여부 */
  isModeStarted: boolean;
  /** 선택 모드 시작/종료 설정 함수 */
  setIsModeStarted: (value: boolean) => void;
  /** 현재 선택된 주문 ID 목록 */
  selectedOrderIds: number[];
  /** 확인 모달 열림 상태 */
  isConfirmModalOpen: boolean;
  /** 확인 모달 열림/닫힘 설정 함수 */
  setIsConfirmModalOpen: (value: boolean) => void;
  /** 특정 주문의 선택 상태를 토글합니다 */
  toggleSelection: (order: Order) => void;
  /** 모든 주문의 선택 상태를 토글합니다 */
  toggleAllSelection: () => void;
  /** 선택 모드를 종료하고 선택을 초기화합니다 */
  resetSelectionMode: () => void;
}

/**
 * 주문 취소 선택 모드 상태 관리 훅
 *
 * 주문 취소를 위한 다중 선택 모드의 UI 상태를 관리합니다.
 * 선택 모드 시작/종료, 주문 선택/해제, 확인 모달 상태 등을 제어합니다.
 */
export function useCancelSelectionMode(
  filteredOrders: Order[]
): CancelSelectionModeResult {
  const [isModeStarted, setIsModeStarted] = useState(false);
  const [selectedOrderIds, setSelectedOrderIds] = useState<number[]>([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const toggleSelection = (order: Order) => {
    setSelectedOrderIds((prev) =>
      prev.includes(order.id)
        ? prev.filter((id) => id !== order.id)
        : [...prev, order.id]
    );
  };

  const toggleAllSelection = () => {
    const selectableOrders = filteredOrders
      .filter((o) => !o.isCanceled && !o.isPackConfirmed)
      .map((o) => o.id);

    const isAllSelected = selectedOrderIds.length === selectableOrders.length;
    setSelectedOrderIds(isAllSelected ? [] : selectableOrders);
  };

  const resetSelectionMode = () => {
    setIsModeStarted(false);
    setSelectedOrderIds([]);
    setIsConfirmModalOpen(false);
  };

  return {
    isModeStarted,
    setIsModeStarted,
    selectedOrderIds,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    toggleSelection,
    toggleAllSelection,
    resetSelectionMode,
  };
}
